// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3ao15","totalLine":"styles_totalLine__2sq__"};